import { Component, OnInit } from '@angular/core';
import{ Chart} from 'chart.js';
import { MatTableDataSource} from '@angular/material/table';
import { Router } from '@angular/router'



@Component({
  selector: 'app-ictpractical',
  templateUrl: './ictpractical.component.html',
  styleUrls: ['./ictpractical.component.css']
})
export class IctpracticalComponent implements OnInit {

  public barChartOptions = {
    scaleShowVerticalLines: false,
    responsive: true,
  };
    
  public barChartLabels = ['2006','2007','2008','2009','2010','2011','2012'];
  public barChartType = 'bar';
  public barChartLegend = true;
  
  
  public barChartData = [
    {data:[65, 59, 80, 81,56,55,40], label:'Series A'},
    {data:[28, 48, 40,19, 86, 27,90], label: 'Series B'}
  ];
  public pieChartOptions = {
    scaleShowVerticalLines: false,
    responsive: true,
  };
    
  public pieChartLabels = ['sales 1','sales 2','sales 3','sales 4'];
  public pieChartType = 'pie';
  public pieChartLegend = true;
  
  
  public pieChartData = [
    {data:[120, 100, 56, 70] },
    
  ];
  
  public lineChartOptions = {
    scaleShowVerticalLines: false,
    responsive: true,
  };
    
  public lineChartLabels = ['2006','2007','2008','2009','2010','2011','2012'];
  public lineChartType = 'line';
  public lineChartLegend = true;
  
  
  public lineChartData = [
    {data:[65, 59, 80, 81,56,55,40], label:'Series A'},
    {data:[28, 48, 40,19, 86, 27,90], label: 'Series B'}
  ];
  

  constructor() { }

  ngOnInit(): void {
  }

}
